import { ReactNode } from 'react';
import style from './Heading.module.scss';
import Logo from '@/components/Logo';

export interface HeadingProps {
  title?: string;
  className?: string;
  children?: ReactNode;
  showHeadingLogo?: boolean;
}

const Heading = ({ title, children, className, showHeadingLogo = false }: HeadingProps) => {
  return (
    <>
      <div className={`${style.heading} ${className}`}>
        <div className={style.logo__title__container}>
          {showHeadingLogo && (
            <Logo
              type="primary"
              className={`${style.heading__logo}`}
            />
          )}
          <div className={style.heading__title}>{title}</div>
        </div>
        <div>{children}</div>
      </div>
    </>
  );
};

export default Heading;
